import React, { Component } from 'react'
import classNames from 'classnames'
import { Radio as AntRadio } from 'antd'
import './Radio.scss'

export default class RadioGroup extends Component {

  render() {
    const className = classNames(this.props.className, 'pan-radio', 'pan-radio-radioGroup')
    return <AntRadio.Group {...this.props} className={className}/>
  }

}
